// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationRequirementApi,
  ICertificationRequirementApiRequest,
  ICertificationRequirementApiGetAllAttrs,
  ICertificationRequirementApiGetAllResponse,
  ICertificationRequirementApiGetAttrs,
  ICertificationRequirementApiGetResponse,
  ICertificationRequirementApiSaveAttrs,
  ICertificationRequirementApiSaveResponse,
} from 'interfaces/back-office/content-management/certification/requirement/certification-requirement-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'
import { IBaseApiRequestPayload } from 'interfaces/api'

export class CertificationRequirementApi
  extends BaseApi<ICertificationRequirementApi>
  implements ICertificationRequirementApiRequest
{
  readonly url = ApiConstant.CONTENT_CERTIFICATION_REQUIREMENT_URL
  private certificationRequirementUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home welcomes
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationRequirementApiGetAllAttrs} payload
   *
   * @return {Promise<ICertificationRequirementApiGetAllResponse>} Promise<ICertificationRequirementApiGetAllResponse>
   */
  async certificationRequirement_getCertificationRequirements(
    payload: ICertificationRequirementApiGetAllAttrs,
  ): Promise<ICertificationRequirementApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.certificationRequirementUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationRequirementApiGetAttrs} payload
   *
   * @return {Promise<ICertificationRequirementApiGetResponse>} Promise<ICertificationRequirementApiGetResponse>
   */
  async certificationRequirement_getCertificationRequirement(
    payload: ICertificationRequirementApiGetAttrs,
  ): Promise<ICertificationRequirementApiGetResponse> {
    try {
      const response = await this.POST(
        `${this.certificationRequirementUrl}/${payload.params.id}`,
        {},
        { ...payload.requestConfig },
      )

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationRequirementApiSaveAttrs} payload
   *
   * @return {Promise<ICertificationRequirementApiSaveResponse>} Promise<ICertificationRequirementApiSaveResponse>
   */
  async certificationRequirement_saveCertificationRequirement(
    payload: ICertificationRequirementApiSaveAttrs,
  ): Promise<ICertificationRequirementApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id
          ? `${this.certificationRequirementUrl}/update/${payload.params.id}`
          : `${this.certificationRequirementUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
